import ThisModule from "./ImageUploader";

export default ThisModule;
